import { useAuth } from '../context/AuthContext'
import EmployerDashboard from './EmployerDashboard'
import EmployeeDashboard from './EmployeeDashboard'
import HelpAssistant from '../components/HelpAssistant'

export default function Dashboard() {
  const { profile } = useAuth()
  if (!profile) return <p style={{ padding: '2rem' }}>Loading…</p>
  return (
    <>
      {profile.role === 'employer' ? <EmployerDashboard /> : <EmployeeDashboard />}
      <HelpAssistant />
    </>
  )
}